import React from "react";
import Insecticides from "./insecticides";

function page(){
    return(

        <>
        <Insecticides />
        </>

    );
}
export default page;